// extracted by mini-css-extract-plugin
export default {"container":"vk-z","disabled":"wk-z","subtotal":"xk-z","legal":"yk-z"};